import React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from './messages';

import './CardResultDisciplineContent.scss';

function getWidth(grade, hasSimplificaSpainReports) {
  if (!parseFloat(grade)) return '1px';
  const width = hasSimplificaSpainReports ? parseFloat(grade) * 10 : grade;
  return `${width}%`;
}

function formatGrade(grade, hasSimplificaSpainReports) {
  if (!hasSimplificaSpainReports) return `${grade}%`;
  return `${grade}/10`.replace('.', ',');
}

const CardResultDisciplineContent = ({ catalogings, title, hasSimplificaSpainReports }) => (
  <div className="card">
    <div className="card-body">
      <div className="card-title-alt mb-4">
        <i className="ti-layers-alt mr-1" /> {hasSimplificaSpainReports ? <FormattedMessage {...messages.averageScoreCriterion} /> : title}
      </div>
      <div className="bar-chart bar-chart-compact horizontal-bars-chart pr-2">
        <div className="bar-chart-wrapper">
          {catalogings.map(({ name, grade }) => (
            <div className="bc-row" key={Math.random()}>
              <p className="plus-padding">{name}</p>
              <div
                className="bc-bar bc--orange"
                style={{ width: getWidth(grade, hasSimplificaSpainReports) }}
              >
                <div className="bc-bar-value">{formatGrade(grade, hasSimplificaSpainReports)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default CardResultDisciplineContent;
